import { inject, Injectable } from '@angular/core'

import { LogLevel } from '../log-level.enum'
import { LogTransport } from '../log-transport'
import { CLOUD_WATCH_LOG_TRANSPORT_CONFIG } from './cloud-watch-log-transport-config.injection-token'
import { CloudWatchLogger } from './cloud-watch-logger.service'

/**
 * The LogTransport implementation using {@link CloudWatchLogger}.
 * Delegates all logging logic to the CloudWatchLogger.
 * Requires the {@link CLOUD_WATCH_LOG_TRANSPORT_CONFIG} to be provided.
 */
@Injectable({ providedIn: 'root' })
export class CloudWatchLogTransport extends LogTransport {
  private readonly cloudWatchLogger = inject(CloudWatchLogger)
  readonly logLevel = inject(CLOUD_WATCH_LOG_TRANSPORT_CONFIG).logLevel

  log(level: LogLevel, clazzName: string, _color: string, timestamp: Date, args: any[]): void {
    // checking the log level is done in the cloudWatchLogger. important.
    this.cloudWatchLogger.logMessage(level, clazzName, timestamp, args)
  }
}
